
import { TimeIntervalEnum } from "../enums/timeIntervalEnum";

import * as appsettings from "../appsettings";
import * as main from "../main";
import * as timeinterval from "../timeinterval";



let dateTimeErrorMessageLabel = "";

/*
* Show / Hide Period Selector
**/
function setVisibilityPeriodSelector(): void {
    const timeinterval_value = parseInt($("#TimeInterval").data("kendoDropDownList").value());

    if (timeinterval_value == TimeIntervalEnum.AskedPeriod) {
        $("#periodSelector").show();
    } else {
        $("#periodSelector").hide();
    }
}

/**
* Initialize
*/
export function initialize(dateTimeErrorMessage: string): void {
    dateTimeErrorMessageLabel = dateTimeErrorMessage;

    main.setHideDiv("errorMessage", false);
    $("#UserPiketReportExportButtonLoader").hide();
    setVisibilityPeriodSelector();
}

/**
* onChange for TimeInterval (show / hide periodSelector)
*/
export function onChangeTimeInterval(): void {
    setVisibilityPeriodSelector();
}

/**
* Action export (will download excel document according to the selected period)
*/
export function exportAction(e: kendo.ui.ButtonClickEvent): void {
    //stop the browser from following
    e.preventDefault();

    main.setHideDiv("errorMessage", false);

    // Show the waiting indicator
    $("#UserPiketReportExportButtonLoader").show();

    // get preference / options selected
    const selectedGroupId = Number($("#GroupId").data("kendoDropDownList").value());
    const selectedInterval = Number($("#TimeInterval").data("kendoDropDownList").value());

    // Get selection period
    let beginPeriodSelectionString = "";
    let beginPeriodSelection = timeinterval.getBeginPeriodSelection(selectedInterval, "StartSelection");
    if (beginPeriodSelection != null) {
        beginPeriodSelectionString = beginPeriodSelection.toUTCString();
    }

    let endPeriodSelectionString = "";
    let endPeriodSelection = timeinterval.getEndPeriodSelection(selectedInterval, "EndSelection");
    if (endPeriodSelection != null) {
        endPeriodSelectionString = endPeriodSelection.toUTCString();
    }

    if (beginPeriodSelectionString != "" && endPeriodSelectionString != "") {
        // Download File
        $.fileDownload(appsettings.getLocalUrl('UserPiketReport/Export?groupId=' + selectedGroupId + "&timeInterval=" + selectedInterval + "&start=" + beginPeriodSelectionString + "&end=" + endPeriodSelectionString))
            .done(function () { $("#UserPiketReportExportButtonLoader").hide(); })
            .fail(function () { $("#UserPiketReportExportButtonLoader").hide(); });
    }
    else {
        // Hide Indicator
        $("#UserPiketReportExportButtonLoader").hide();

        // make a message
        main.setHideDiv("errorMessage", true);

        const lblError = $("#errorMessageLabel");
        if (lblError != null && lblError != undefined) {
            lblError.text(dateTimeErrorMessageLabel);
        }
    }
}


/**
* Checks Passwordfield and Pasword2 field have identical values.
* Is called on leaving Password2 field.
*/
export function startChange(): void {
    const start = $("#StartSelection").data("kendoDateTimePicker");
    const end = $("#EndSelection").data("kendoDateTimePicker");
    let startDate = start.value();
    let endDate = end.value();

    if (startDate) {
        startDate = new Date(startDate);
        startDate.setDate(startDate.getDate());
        end.min(startDate);
    } else if (endDate) {
        start.max(new Date(endDate));
    } else {
        endDate = new Date();
        start.max(endDate);
        end.min(endDate);
    }
}

/**
* Checks Passwordfield and Pasword2 field have identical values.
* Is called on leaving Password2 field.
*/
export function endChange(): void {
    const start = $("#StartSelection").data("kendoDateTimePicker");
    const end = $("#EndSelection").data("kendoDateTimePicker");
    let endDate = end.value();
    let startDate = start.value();

    if (endDate) {
        endDate = new Date(endDate);
        endDate.setDate(endDate.getDate());
        start.max(endDate);
    } else if (startDate) {
        end.min(new Date(startDate));
    } else {
        endDate = new Date();
        start.max(endDate);
        end.min(endDate);
    }
}

